import Vue from "vue";
import Vuex from "vuex";
import forms from "./forms";
import assets from "./assets";
import provider from "./provider";
import heartbeats from "./heartbeats";
import listings from "./listings";
import places from "./places";
import resources from "./resources";
import session from "./session";
import settings from "./settings";
import stripe from "./stripe";
import tools from "./tools";
import user from "./user";
import admin from "./admin";
import service from "./service";
import ai from "./ai";
import events from "./events";
import schedule from "./schedule";
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    admin,
    ai,
    assets,
    events,
    forms,
    heartbeats,
    provider,
    listings,
    places,
    resources,
    service,
    session,
    settings,
    stripe,
    tools,
    user,
    schedule
  }
});

export default store;
